import React from "react";
/**
 * This hook is used to set state for multiple values in a dictionary.
 * It returns 4 items -  a getter, setter and the traditional object and a setter for the object.
 * The first getter and setter are to read and write to individual properties.
 *
 * @export
 */
const useFields = (defaultValues) => {
    let [obj, setObj] = React.useState(defaultValues);
    let setter = {};
    let getter = {};
    let fieldNames = Object.keys(defaultValues);
    for (let i in fieldNames) {
        let fn = fieldNames[i];
        let setField = (v) => {
            let t = {};
            t[fn] = v;
            let newObj = Object.assign({}, obj, t);
            setObj(newObj);
        };
        setter[fn] = setField;
        getter[fn] = obj[fn];
    }
    return [getter, setter, obj, setObj];
};
export default useFields;
